import { sendGTMEvent } from '@next/third-parties/google';
export function onRouteChangeComplete(page: string) {
  sendGTMEvent({ event: 'pageview', page });
}
